document.addEventListener('DOMContentLoaded', function () {
  initHeroCarrusel();
  initReveals();
  initContador();
  initMarquesina();
  initColorSelector();
});

/* Carrusel de fondo del hero: cambia de foto sola cada X segundos.
   Si el usuario tiene activado "reducir movimiento", se sigue cambiando de
   foto (no se congela en la primera para siempre), solo que sin la
   transición suave de opacidad: es un salto directo en vez de un fundido. */
function initHeroCarrusel() {
  var escenas = document.querySelectorAll('[data-mt-hero-carrusel]');
  if (!escenas.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  escenas.forEach(function (escena) {
    var imgs = escena.querySelectorAll('[data-mt-hero-slide]');
    if (imgs.length < 2) return;

    if (reduce) {
      imgs.forEach(function (img) { img.style.transition = 'none'; });
    }

    var velocidad = parseInt(escena.getAttribute('data-mt-velocidad'), 10) || 6000;
    if (isNaN(velocidad) || velocidad < 500) velocidad = 6000;
    var actual = 0;

    setInterval(function () {
      var siguiente = (actual + 1) % imgs.length;
      imgs[actual].style.opacity = '0';
      imgs[siguiente].style.opacity = '1';
      actual = siguiente;
    }, velocidad);
  });
}

/* Animación de entrada al hacer scroll, compartida por toda la tienda */
function initReveals() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  els.forEach(function (el) { observer.observe(el); });
}

/* Cifras animadas (count-up) */
function initContador() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        var el = entry.target;
        var fin = parseFloat(el.getAttribute('data-mt-contador')) || 0;
        var sufijo = el.getAttribute('data-mt-sufijo') || '';

        if (reduce) {
          el.textContent = fin + sufijo;
          return;
        }

        var duracion = 1400;
        var inicio = null;
        function paso(ts) {
          if (!inicio) inicio = ts;
          var progreso = Math.min((ts - inicio) / duracion, 1);
          var facil = 1 - Math.pow(1 - progreso, 3);
          var valor = Math.round(fin * facil);
          el.textContent = valor + sufijo;
          if (progreso < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      });
    },
    { threshold: 0.5 }
  );

  els.forEach(function (el) { observer.observe(el); });
}

/* Marquesina infinita (reseñas / franja de confianza) */
function initMarquesina() {
  var tracks = document.querySelectorAll('[data-mt-marquesina]');
  if (!tracks.length) return;

  tracks.forEach(function (track) {
    if (track.dataset.mtDuplicado) return;
    var contenido = track.innerHTML;
    track.innerHTML = contenido + contenido;
    track.dataset.mtDuplicado = 'true';
  });
}

/* Selector de color del producto: cambia la imagen mostrada */
function initColorSelector() {
  var grupos = document.querySelectorAll('[data-mt-selector-color]');
  grupos.forEach(function (grupo) {
    var botones = grupo.querySelectorAll('[data-mt-color]');
    var imagen = grupo.querySelector('[data-mt-color-imagen]');
    if (!botones.length || !imagen) return;

    botones.forEach(function (btn) {
      btn.addEventListener('click', function () {
        botones.forEach(function (b) { b.classList.remove('mt-color-activo'); });
        btn.classList.add('mt-color-activo');
        var nuevaSrc = btn.getAttribute('data-mt-color-src');
        if (nuevaSrc) {
          imagen.style.opacity = '0';
          setTimeout(function () {
            imagen.setAttribute('src', nuevaSrc);
            imagen.style.opacity = '1';
          }, 200);
        }
      });
    });
  });
}
